import { MButton } from '@assets/mui/@material-extend';
import { deleteFavoritesProduct } from '@context/useBitrixUser/useBitrix';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { ProductRouteExistLimitStyledContainer } from '@pages/Favorites/components/DeleteFavoriteProductConfirmDialog/StyledComponents';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Пропсы компонента
 */
type DeleteFavoriteConfirmDialogProps = {
  favoriteId: string | null;
  onClose: () => void;
};

/**
 * Подтверждение удаления из избранного
 */
export const DeleteFavoriteConfirmDialog = ({
  favoriteId,
  onClose,
}: DeleteFavoriteConfirmDialogProps) => {
  const { t } = useTranslation(['CartComponent']);

  const confirmHandler = () => {
    if (favoriteId) {
      deleteFavoritesProduct({ id: favoriteId });
    }

    onClose();
  };

  return (
    <Dialog fullWidth maxWidth={'sm'} open={!!favoriteId} onClose={onClose} scroll={'body'}>
      <ProductRouteExistLimitStyledContainer>
        <Typography variant={'h2'}>
          {t('CartComponent:DeleteFavoritesProductDialog.DeleteSingle')}
        </Typography>
        <div className="action-wrapper">
          <MButton onClick={confirmHandler} variant={'outlined'} color={'error'} fullWidth={true}>
            {t('CartComponent:DeleteFavoritesProductDialog.Yes')}
          </MButton>
          <MButton onClick={onClose} variant={'outlined'} color={'primary'} fullWidth={true}>
            {t('CartComponent:DeleteFavoritesProductDialog.No')}
          </MButton>
        </div>
      </ProductRouteExistLimitStyledContainer>
    </Dialog>
  );
};
